module.exports = {
      id: "posters_machines-usage",
      viewBox: "0 0 353.6 305.52",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#posters_machines-usage",
      toString: function () {
        return this.url;
      }
    }